<template>
  <a-layout class="nhf-app">
    <a-spin :spinning="lineLoading" tip="配方优化中，请稍后">
      <a-layout-content class="nhf-editor">
        <a-row justify="space-between" type="flex" class="nhf-header">
          <h1 class="nhf-title" @click="goBack">
            <img class="nhf-logo" :src="logo" alt="返回上一页面" />
            <span>{{ factoryName }}</span>
          </h1>
          <a-space>
            <!-- <a-dropdown >
              <a-button icon="layout" size="small" style="font-size:22px"></a-button>
               <a-menu slot="overlay" @click="handleLayout">
                <a-menu-item key="layoutType">切换布局 </a-menu-item> 
                <a-menu-item key="showSider" class="vue-simple-context-menu__item"><span>配方原料表 <i v-if="layout.showSider" /></span></a-menu-item>
                <a-menu-item key="showRight"  class="vue-simple-context-menu__item"><span>配方营养需要量 <i v-if="layout.showRight" /></span></a-menu-item>
              </a-menu>
            </a-dropdown> -->

            <a-button
              type="primary"
              size="small"
              @click="changeLinear({ key: 1 })"
              >配方优化</a-button
            >
            <a-button size="small" @click="changeLinear({ key: 2 })"
              >取整优化</a-button
            >
            <!-- <a-dropdown style="width:90px"> -->
            <!-- <a-button size="small">配方优化</a-button>
              <a-menu slot="overlay" @click="changeLinear">
                <a-menu-item key="1">仅优化</a-menu-item>
                <a-menu-item key="2">优化取整</a-menu-item>
              </a-menu> -->
            <!-- </a-dropdown> -->
            <a-button
              :disabled="detail.isProduct == 0"
              size="small"
              @click="togglePorductVisible"
              >产品对比</a-button
            >
            <a-dropdown>
              <a-button size="small" ghost type="primary">查看报表</a-button>
              <a-menu slot="overlay" @click="viewReport">
                <a-menu-item
                  :key="index + 1"
                  v-for="(item, index) in ['配方报表', '生产报表']"
                  >{{ item }}</a-menu-item
                >
              </a-menu>
            </a-dropdown>
            <a-dropdown>
              <a-button
                size="small"
                :loading="saveLoading"
                style="width: 84px"
                type="primary"
                >保存</a-button
              >
              <a-menu slot="overlay" @click="saveFormula">
                <a-menu-item
                  v-for="(item, index) in ['仅保存', '更新版本', '生成产品']"
                  :key="index"
                  >{{ item }}</a-menu-item
                >
                <!-- <a-menu-item v-for="(item,index) in ['更新版本','生成产品']" :key="index">{{item}}</a-menu-item> -->
              </a-menu>
            </a-dropdown>
          </a-space>
        </a-row>
        <div class="nhf-container" ref="editorContainer">
          <a-row
            type="flex"
            align="middle"
            class="nhf-header-main"
            justify="space-between"
          >
            <a-space>
              <h3>{{ detail.formulaName }}</h3>
              <a-icon
                size="small"
                style="font-size: 15px"
                @click="toggleEditorVisible"
                type="form"
              />
            </a-space>
            <a-row
              type="flex"
              align="middle"
              justify="space-between"
              style="padding: 0 20px"
            >
              <div class="col">
                混合日粮初始价格(元)
                <h2>
                  {{
                    !formulaExtMix.mixLastPrice
                      ? "0.000"
                      : formulaExtMix.mixLastPrice.toFixed(3)
                  }}
                </h2>
                <!-- <p v-if="hasProductVersion" style="color: transparent;height: 18px;"></p> -->
              </div>
              <a-divider type="vertical" />
              <div class="col">
                混合日粮优化价格(元)
                <h2>
                  {{
                    !formulaExtMix.mixPrice
                      ? "0.000"
                      : formulaExtMix.mixPrice.toFixed(3)
                  }}
                  <span
                    v-if="mixComputedPrice != 0.0"
                    :class="{
                      red: mixComputedPrice > 0,
                      green: mixComputedPrice < 0,
                    }"
                  >
                    <b>/</b>{{ mixComputedPrice }}
                    <a-icon style="font-size: 16px" :type="mixPriceType" />
                  </span>
                </h2>
                <!-- <p v-if="hasProductVersion" style="color: transparent;height: 18px;"></p> -->
              </div>
              <a-divider type="vertical" />
              <div class="col">
                补充料初始价格(元/吨)
                <!-- <h2>{{detail.lastPrice === null ? '0.000' : ((detail.lastPrice || 0) * (blendWeight || 0) / (detail.totalWeight || 1)).toFixed(3)}}</h2> -->
                <h2>
                  {{
                    detail.lastPrice === null
                      ? "0.000"
                      : (detail.lastPrice || 0).toFixed(3)
                  }}
                </h2>
                <!-- <p v-if="hasProductVersion" style="color: transparent;height: 18px;"></p> -->
              </div>
              <a-divider type="vertical" />
              <div class="col">
                补充料优化价格(元/吨)
                <!-- <h2>{{detail.price === null ? '0.000' : ((detail.price || 0) * (blendWeight || 0) / (detail.totalWeight || 1)).toFixed(3)}}
                  <span v-if="computedPrice != 0.00" :class="{red:computedPrice >0,green:computedPrice<0}">
                    <b>/</b>{{computedPrice}} <a-icon style="font-size:16px" :type="priceType" />
                  </span>
                </h2> -->
                <h2>
                  {{
                    detail.price === null
                      ? "0.000"
                      : (detail.price || 0).toFixed(3)
                  }}
                  <span
                    v-if="computedPrice != 0.0"
                    :class="{
                      red: computedPrice > 0,
                      green: computedPrice < 0,
                    }"
                  >
                    <b>/</b>{{ computedPrice }}
                    <a-icon style="font-size: 16px" :type="priceType" />
                  </span>
                </h2>
                <!-- <p v-if="hasProductVersion" style="color: transparent;height: 18px;"></p> -->
              </div>
              <a-divider type="vertical" />
              <div class="col">
                产品价格(元/吨)
                <h2>
                  <span v-if="productPrice">{{
                    !productPrice.price
                      ? "0.000"
                      : productPrice.price.toFixed(3)
                  }}</span>
                  <span
                    v-if="
                      computedProductPrice != 0.0 && productPrice.version > 0
                    "
                    :class="{
                      red: computedProductPrice > 0,
                      green: computedProductPrice < 0,
                    }"
                  >
                    <b>/</b>{{ Number(computedProductPrice).toFixed(3) }}
                    <a-icon style="font-size: 16px" :type="productPriceType" />
                  </span>
                  <span
                    style="
                      font-weight: normal;
                      color: rgba(0, 0, 0, 0.65);
                      font-size: 12px;
                      margin-left: 3px;
                    "
                    v-if="hasProductVersion"
                    >({{ productPrice.createTime }}，V{{
                      productPrice.version
                    }})</span
                  >
                </h2>
                <!-- <p v-if="hasProductVersion">({{productPrice.createTime}}，V{{productPrice.version}})</p> -->
              </div>
            </a-row>
          </a-row>
          <!-- layout 1 -->
          <div
            class="nhf-layout"
            ref="box"
            style="overflow: hidden"
            :style="{ height: 'calc(100% - 60px)' }"
          >
            <!-- 左侧 -->
            <div
              class="tableleft"
              style="height: calc(100%); position: relative; width: 50%"
            >
              <div
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 5px;
                  bottom: 10px;
                  z-index: 1000;
                  background: #fff;
                "
                v-if="nutVisible"
              >
                <nutrition-raw-box ref="nutritionRawBox" />
              </div>
              <div class="leftBoxTopHeight" style="" ref="leftBoxTopHeight">
                <raw-editor
                  style="height: 100%"
                  @refresh="refreshUpdate"
                  @getRes="getRes"
                  @prcieChange="prcieChange"
                  ref="rawBlockTop"
                  @add="toggleRawPanel"
                  :weightNum="mixWeight"
                  @ok="calculation"
                  @countPrice="countPrice"
                ></raw-editor>
              </div>
              <div
                class="resizeBottom"
                :span="1"
                title="上下拖动调整高度"
              ></div>

              <div class="tableBottom" style="" ref="leftBoxBottomHeight">
                <raw-editor2
                  style="height: calc(100% - 20px)"
                  @refresh="refreshUpdate"
                  @getRes="getRes"
                  @countPrice="countPrice"
                  @prcieChange="prcieChange"
                  ref="rawBlockBottom"
                  @add="toggleRawPanel"
                  :weightNum="blendWeight"
                ></raw-editor2>
              </div>
            </div>

            <!-- 中线 -->
            <div class="resize" :span="1" title="左右拖动调整宽度"></div>

            <!-- 右侧 -->
            <div
              class="tableright"
              style="
                position: relative;
                height: calc(100% - 20px);
                width: 49.6%;
              "
            >
              <div
                style="
                  position: absolute;
                  top: 0;
                  left: 5px;
                  right: 0;
                  bottom: 0px;
                  z-index: 1000;
                  background: #fff;
                "
                v-if="calculaVisible"
              >
                <calcula-box-modal
                  ref="calculaBoxModal"
                  @refresh="refreshList"
                  @getRes="getRes"
                />
              </div>
              <nutrition-editor
                style="padding-left: 15px"
                @refresh="totalRefreshUpdate"
                ref="nutritionBlock"
                @res="getDetail"
                @changeTab="changeTab"
                @ok="calculation"
                :hasProductVersion="hasProductVersion"
              >
                <a-button
                  type="primary"
                  :disabled="!nutRows.length"
                  ghost
                  @click="toggleHidden('nutRows')"
                  size="small"
                  >营养养分控制</a-button
                >
              </nutrition-editor>
            </div>
          </div>
        </div>
      </a-layout-content>
      <!-- <product-modal :hidden="productVisible" @cancel="togglePorductVisible" /> -->
      <product-comparison
        :hidden="productVisible"
        @cancel="togglePorductVisible"
      />
      <compound-create-modal
        ref="editRow"
        :hidden="editorVisible"
        @ok="update"
        @cancel="toggleEditorVisible"
      />
      <analyse-modal
        :rawitem="rawRows"
        :hidden="analyseVisible"
        @close="toggleAnalyse"
      />
    </a-spin>
  </a-layout>
</template>

<script>
import { nhfMixins } from '../untils'
import logo from '../../../assets/images/logo_nhf.svg'
import NutritionEditor from './editor/NutritionEditor.vue'
import RawEditor from './editor/RawEditor.vue'
import RawEditor2 from './editor/RawEditor2.vue'
import AnalyseModal from './modal/AnalyseModal.vue'
import CompoundCreateModal from './modal/CompoundCreateModal.vue'
// import ProductModal from './modal/ProductModal.vue'
import ProductComparison from './modal/ProductComparison.vue'
import NutritionRawBox from './modal/NutritionRawBox.vue'
import CalculaBoxModal from './modal/CalculaBoxModal.vue'
// import VueSimpleContextMenu from 'vue-simple-context-menu'
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css'
import { getRequest } from "@/components/Common/Utils/Utils";

export default {
  components: {
    NutritionEditor,
    NutritionRawBox,
    RawEditor,
    RawEditor2,
    CalculaBoxModal,
    ProductComparison,
    // ProductModal, 
    CompoundCreateModal,
    AnalyseModal
  },
  mixins: [nhfMixins],
  data() {
    return {
      factoryName: window.localStorage.getItem("factoryName"),
      logo,
      editorContainerHeight: 400,
      resultVisible: false,
      saveLoading: false,
      productVisible: false,
      editorVisible: false,
      lineLoading: false,
      top: 0,
      goodLoading: false,
      rawVisible: false,
      nutritenVisible: false,
      nutritenDetailVisible: false,
      needVisible: false,
      needType: null,
      productPrice: {},
      updateLoading: false,
      refreshNoticeCompound: null,
      tabSelect: "1",
      analyseVisible: false,
      blendWeight: 0,
      mixWeight: 0,
      formulaExtMix: {}
    }
  },
  mounted() {
    this.contrastTargetAddDiff()
    this.getNutrition()
  },
  beforeDestroy() {
    clearInterval(this.refreshNoticeCompound)
    this.refreshNoticeCompound = null
  },
  watch: {
    'layout.layoutType'() {
      this.init()
      this.getContainerHeight()
    },
  },
  computed: {
    hasProductVersion() {
      let version = false
      if (this.productPrice && this.productPrice.version > 0) version = true
      return version
    },
    leftStyle() {
      const { showRight, showSider } = this.layout
      let width = showRight ? '50%' : ''
      if (!showRight && !showSider) width = '100%'
      return {
        width
      }
    },
    rightStyle() {
      const { showRight } = this.layout
      let width = showRight ? '49.6%' : ''
      return {
        width
      }
    },
    layoutOption() {
      const { showSider, showRight, layoutType } = this.layout
      const item = [
        {
          type: 'divider'
        },
        {
          name: `<b>配方原料列表</b> ${showSider ? '<i />' : ''}`,
          commit: 'showSider'
        },
        {
          name: `<b>配方营养需要量</b> ${showRight ? '<i />' : ''}`,
          commit: 'showRight'
        }
      ]
      const base = [
        {
          name: `布局切换`,
          commit: 'layoutType'
        }
      ]
      return layoutType ? [...base, ...item] : base
    },
    computedPrice() {
      const { price, lastPrice } = this.detail
      return lastPrice != null && price != null ? (price).sub(lastPrice).toFixed(3) : ''
    },
    computedProductPrice() {
      let { price } = this.productPrice || {}
      let { price: detailsPrice } = this.detail
      return price != null && detailsPrice != null ? (- price + detailsPrice).toFixed(3) : ''
    },
    mixComputedPrice() {
      const { mixPrice, mixLastPrice } = this.formulaExtMix
      return mixLastPrice != null && mixPrice != null ? (mixPrice).sub(mixLastPrice).toFixed(3) : ''
    },
    priceType() {
      return this.computedPrice > 0 ? 'arrow-up' : 'arrow-down'
    },
    mixPriceType() {
      return this.mixComputedPrice > 0 ? 'arrow-up' : 'arrow-down'
    },
    productPriceType() {
      return this.computedProductPrice > 0 ? 'arrow-up' : 'arrow-down'
    }
  },

  methods: {
    contrastTargetAddDiff() {
      let params = {
        formulaId: getRequest('id')
      }
      this.$http.get('/nhf-app/formulaManage/contrastTargetAddDiff', { params }).then(res => {
        let { success } = res || {}
        if (success) this.initMounted()
      })
    },
    initMounted() {
      setTimeout(() => {
        this.getContainerHeight()
        this.setState({ calculaVisible: false, nutVisible: false })
      }, 500)
      this.init()
      this.getFactoryDetails()
    },
    countPrice({ count, index }) {
      if (index == 2) {
        if (this.detail.price != count) {
          this.detail.price = Number(count) || 0

          this.updatePrice(this.detail)
        }
      } else if (index === 1) {
        if (this.detail.formulaExtMix && (this.detail.formulaExtMix.dayPrice != count)) {
          this.detail.formulaExtMix.dayPrice = Number(count.toFixed(3))
          let price2 = !this.detail.price ? 0 : Number((this.detail.price || 0) * (this.blendWeight || 1) / (this.detail.totalWeight || 1)).toFixed(3)
          this.formulaExtMix.mixPrice = Number((count + Number(price2)).toFixed(3))
          this.updatePrice(this.detail)
        }
      }

    },

    async updatePrice(data) {
      await this.fetchPost({
        actions: this.updateFormulaMixPrice,
        loading: "updateLoading",
        showMessage: false,
        data,
      });
    },
    async getNutrition() {
      const res = await this.fetchGet({
        actions: this.animalNutritionUserPage,
        showMessage: false,
        data: {
          size: 1000, current: 1
        },
      })
      let { success, data } = res || {}
      if (success) {
        this.setState({ nutritionList: data.records || [] })
      }
    },
    getFactoryDetails() {
      let id = window.localStorage.getItem('factoryId')
      if (!id) {
        this.$get('/iot-factory/factory/detail', { id }).then(res => {
          let { success, data } = res || {}
          if (success) {
            let { overseasFlag } = data || {}
            this.overseasFlag = overseasFlag
            if (overseasFlag != window.localStorage.getItem('overseasFlag')) {
              window.localStorage.setItem('overseasFlag', overseasFlag)
            }

            // 存一个工厂的详细信息
            window.localStorage.setItem('factoryDetail', JSON.stringify(data))
          }
        })
      }
    },
    calculation(list) {
      this.$refs['calculaBoxModal'].setResult(list)
    },
    changeTab() {
      this.$refs.nutritionRawBox && this.$refs.nutritionRawBox.resetList()
    },
    async init() {
      const { id } = this.$route.query
      this.formulaId = id
      await this.refreshUpdate(this.refreshPage)
      window.onresize = () => this.getContainerHeight()
      this.dragRowDiv()
      setTimeout(() => {
        // if(this.$refs.nutritionBlock) this.$refs.nutritionBlock.init()
        this.dragControllerDiv()
      }, 0);

    },
    removeRaw() {
      this.$refs['rawBlockTop'].removeRaw()
      this.$refs['rawBlockBottom'].removeRaw()
    },
    addRawActions() {
      this.$refs['rawBlockTop'].toggleRawVisible()
      this.$refs['rawBlockBottom'].toggleRawVisible()
    },
    goBack() {
      this.$router.push('/nhf/blend?name=混合日粮')
    },
    handleLayout(e) {
      this.toggleLayout(e.key)
    },
    handleMenu(event) {
      this.$refs.contextMenuContainer.showMenu(event)
    },
    menuChecked({ option }) {
      const { commit } = option
      this.toggleLayout(commit)
    },

    toggleHasAnalyse() {
      this.rawRows.length > 1 ? this.$message.warn('只能选中一个原料') : this.toggleAnalyse()
    },

    // 梯度分析
    toggleAnalyse() {
      this.analyseVisible = !this.analyseVisible
    },

    getContainerHeight() {
      const boxHeight = this.$refs['editorContainer'] ? this.$refs['editorContainer'].offsetHeight : 500
      const height = boxHeight - 160
      // const box = this.$refs.editorContainer
      this.editorContainerHeight = height
      let num = 70
      let bottomNum = 75
      // if(this.productPrice.version > 0) {
      //   num = 100
      //   bottomNum = 75
      // }
      let top = boxHeight / 3
      let bottom = boxHeight - top - num
      if (this.$refs['leftBoxTopHeight']) this.$refs['leftBoxTopHeight'].style.height = top + 'px'
      if (this.$refs['leftBoxBottomHeight']) this.$refs['leftBoxBottomHeight'].style.height = bottom + 'px'
      this.setState({ height, leftBoxTopHeight: top - 80, leftBoxBottomHeight: bottom - bottomNum })
    },

    // 轮循配方通知
    // async refreshCompound(){
    //   //  this.$confirm.destroy()
    //   const {formulaId} = this
    //   const res = await this.fetchGet({
    //     actions:this.formulaNoticePageList,
    //     data:{
    //       formulaId
    //     }
    //   })
    //   return res?.data && res?.data.length > 0 ?  await this.refreshUpdate(this.refreshPage) : res.data
    // },

    // 配方页通知已读
    async refreshUpdate(callback, showMsg = true, record) {
      const { formulaId } = this
      const res = await this.fetchPost({
        actions: this.updateFormulaNoticeStatus,
        loading: 'updateLoading',
        data: { formulaId },
        showMessage: false,
      })
      if (record && record.feild === 'price') {
        console.log('showMsg', showMsg)
        this.$refs['rawBlockTop'].getList({}, record)
        this.$refs['rawBlockBottom'].getList({}, record)
      }
      callback && callback()
      return res
    },
    totalRefreshUpdate() {
      this.getRes()
      this.refreshUpdate()
    },
    getRes(record) {
      // // 配方最优解
      let updateData = {
        "formulaSolutionType": "0",
        "id": getRequest('id')
      }
      this.fetchPost({
        actions: this.updateFormulaFormulaSolutionType,
        data: updateData,
        showMessage: false
      })
      this.detail.formulaSolutionType = '0'
      if (record && record.feild === 'price') {
        this.$refs['rawBlockTop'].getList({}, record)
        this.$refs['rawBlockBottom'].getList({}, record)
      }
    },
    async refreshPage() {
      clearInterval(this.refreshNoticeCompound)
      this.refreshNoticeCompound = null
      await this.getPrice()
      await this.getDetail()
      this.$refs['rawBlockTop'] && this.$refs['rawBlockTop'].getList()
      this.$refs['rawBlockBottom'] && this.$refs['rawBlockBottom'].getList()
      this.refreshList()
    },
    refreshList() {
      this.$refs['nutritionBlock'] && this.$refs['nutritionBlock'].init()
    },

    async changeLinear({ key: optimizationType }) {
      if (this.$refs['rawBlockTop'].cacheData.length == 0) {
        this.$message.warning('请添加日粮后优化')
        return
      }
      if (this.$refs['rawBlockBottom'].cacheData.length == 0) {
        this.$message.warning('请添加补充料后优化')
        return
      }
      let countRationMin = 0
      let countSupplementaryMin = 0
      let rationList = this.$refs["rawBlockTop"].cacheData
      let supplementaryList = this.$refs["rawBlockBottom"].cacheData
      let { selfProvidedProportion = 0 } = this.formulaExtMix
      rationList && rationList.forEach(el => {
        if (el.isExtraProRaw !== '1' && el.isRawDelete !== '1') {
          countRationMin += Number(el.minValue || 0)
        }
      })
      supplementaryList && supplementaryList.forEach(el => {
        if (el.isExtraProRaw !== '1' && el.isRawDelete !== '1') {
          countSupplementaryMin += Number(el.minValue || 0)
        }
      })
      // let f = '<='
      // <p>日粮的最小值总和应 {f} <span style="color: #ff4d4f;">{selfProvidedProportion.toFixed(3)}</span></p>
      // <p>日粮的原料最小值总和：<span style="color: #ff4d4f;">{countRationMin.toFixed(3)}</span></p>
      if (countRationMin > selfProvidedProportion) {
        this.$warning({
          title: '配方无解',
          content: <div>
            <p>日粮原料最小值总和为：<span style="color: #ff4d4f;">{countRationMin.toFixed(3)}</span> ，请调整原料约束!</p>
          </div>,
        });
        return
      }
      // <p>补充料的最小值总和应 {f} <span style="color: #ff4d4f;">{(100 - selfProvidedProportion).toFixed(3)}</span></p>
      // <p>补充料的原料最小值总和：<span style="color: #ff4d4f;">{countSupplementaryMin.toFixed(3)}</span></p>
      if (countSupplementaryMin > (100 - selfProvidedProportion)) {
        this.$warning({
          title: '配方无解',
          content: <div>
            <p>补充料原料最小值总和为：<span style="color: #ff4d4f;">{countSupplementaryMin.toFixed(3)}</span> ，请调整原料约束!</p>
          </div>,
        });
        return
      }
      const data = {
        formulaId: this.formulaId,
        optimizationType
      }
      const res = await this.fetchGet({
        actions: this.mixLinearOptimizationByOptimization,
        data,
        showError: false,
        loading: 'lineLoading'
      })
      if (res && res.success) {
        this.refreshPage()
        this.$message.success(res ? res.msg : '')
      } else {
        this.$warning({
          title: '优化失败',
          content: res.msg,
          // content: '配方无解，请检查配方原料或营养需要量约束条件！',
          cancelText: '确定'
        })
      }
    },

    viewReport({ key }) {
      // let routeUrl = this.$router.resolve({
      //   path:`/nhf-mix-report?id=${this.formulaId}&formulaReportType=${formulaReportType}`
      // })
      // window.open(routeUrl.href, '_blank')
      let url = ['/nhf-app/formulahis/exportFormulaExcelReport', '/nhf-app/formulahis/exportFormulaProExcelReport']

      let aliasFlag = window.localStorage.getItem('overseasFlag') == 1 ? 1 : 0
      this.$fileDownload(url[key - 1], { formulaId: this.formulaId, aliasFlag }).catch(e => {
        e.message && this.$message.error(e.message)
      })
    },

    prcieChange(val) {
      if (val) this.detail.price = val
    },

    async update(data) {
      this.toggleEditorVisible()
      await this.fetchPost({
        actions: this.mixUpdate,
        loading: 'updateLoading',
        data
      })
      this.init()
      if (this.$refs.nutritionBlock) this.$refs.nutritionBlock.init()
    },

    toggleEditorVisible() {
      this.editorVisible = !this.editorVisible
    },

    togglePorductVisible() {
      this.productVisible = !this.productVisible
    },

    tabChange(val) {
      this.tabSelect = val
      this.setState({ rawRows: [], nutRows: [] })
    },

    async linearGood() {
      await this.fetchGet({
        actions: this.linearOptimization,
        loading: 'goodLoading',
        data: {
          formulaId: this.formulaId
        }
      })
      this.refreshPage()
    },

    toggleNeedVisible() {
      if (this.selectNutData.length > 1) {
        this.$message.info(`多个营养指标养分不能同时查看`)
      } else {
        this.needVisible = !this.needVisible
      }
    },

    toggleNutritenVisible() {
      if (this.rawSelect.length > 1) {
        this.$message.info(`多个原料不能同时查看`)
      } else {
        this.nutritenVisible = !this.nutritenVisible
      }
    },

    toggleRawPanel() {
      this.rawVisible = !this.rawVisible
    },

    toggleHidden(name) {
      if (this[name].length > 1) {
        this.$message.info(`多个${this.name == 'raw' ? '原料' : '营养指标养分'}不能同时查看`)
        return
      }
      const visible = name == 'rawRows' ? 'raw' : 'nut'
      this.toggleVisible(visible)
    },
    async getPrice() {
      const productPrice = await this.fetchPost({
        actions: this.getProductPrice,
        showMessage: false,
        data: {
          formulaId: this.formulaId
        }
      })
      this.productPrice = productPrice

      if (productPrice.version > 0) {
        // this.setState({leftBoxBottomHeight: this.leftBoxBottomHeight - 25})
        this.getContainerHeight()
      }
    },
    async getDetail() {
      const res = await this.fetchGet({
        actions: this.mixDetail,
        // name:'detail',
        data: {
          formulaId: this.formulaId,
        }
      })
      if (res && res.data) {
        let { formulaExtMix, totalWeight = 0 } = res.data
        let { selfProvidedProportion = 0 } = formulaExtMix || {}
        this.setState({ detail: res.data })
        this.formulaExtMix = formulaExtMix
        // 日粮重量
        this.mixWeight = totalWeight * selfProvidedProportion / 100
        // 补充料重量
        this.blendWeight = totalWeight * (100 - selfProvidedProportion) / 100
      }
    },
    dragRowDiv() {
      const resize = document.getElementsByClassName('resizeBottom')
      const top = this.$refs.leftBoxTopHeight
      const bottom = this.$refs.leftBoxBottomHeight
      const box = this.$refs.editorContainer
      // const left = document.getElementsByClassName('tableleft')
      // const mid = document.getElementsByClassName('tableBottom')
      // const box = document.getElementsByClassName('nhf-layout')
      for (let i = 0; i < resize.length; i++) {
        resize[i].onmousedown = () => {
          resize[i].style.background = '#e8e8e8'
          let min = 200
          document.onmousemove = e => {
            var endY = e.clientY
            let tHeight = (endY - 105)
            let bHeight = (box.offsetHeight - tHeight)
            if (tHeight < min) {
              tHeight = min
              bHeight = box.offsetHeight - tHeight
            }
            if (bHeight < min + 100) {
              bHeight = min + 100
              tHeight = box.offsetHeight - bHeight
            }
            let hNum = 70
            // if(this.productPrice.version > 0) hNum = 100
            if (tHeight >= min && bHeight >= min) {
              top.style.height = tHeight + 'px'
              bottom.style.height = bHeight - hNum + 'px'
            }
            let leftBottomNum = 145
            let leftTopNum = 80
            // if(this.productPrice.version > 0) {
            //   leftBottomNum = 175
            //   leftTopNum = 80
            // }
            this.setState({ leftBoxTopHeight: tHeight - leftTopNum, leftBoxBottomHeight: bHeight - leftBottomNum })
          };
          document.onmouseup = () => {
            resize[i].style.background = '#fff'
            document.onmousemove = null
            document.onmouseup = null
            resize[i].releaseCapture && resize[i].releaseCapture()
          };
          resize[i].setCapture && resize[i].setCapture()
          return false
        }
      }
    },
    dragControllerDiv() {
      const resize = document.getElementsByClassName('resize')
      const left = document.getElementsByClassName('tableleft')
      const mid = document.getElementsByClassName('tableright')
      const box = document.getElementsByClassName('nhf-layout')
      left[0] && this.setState({ leftWidth: left[0].clientWidth - 24, rightWidth: mid[0].clientWidth - 24 })
      for (let i = 0; i < resize.length; i++) {
        resize[i].onmousedown = e => {
          resize[i].style.background = '#e8e8e8'
          let startX = e.clientX;
          resize[i].left = resize[i].offsetLeft
          document.onmousemove = e => {
            var endX = e.clientX
            var moveLenght = resize[i].left + (endX - startX) // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
            var maxT = box[i].clientWidth - resize[i].offsetWidth // 容器宽度 - 左边区域的宽度 = 右边区域的宽度
            if (moveLenght < 400) moveLenght = 400 // 左边区域的最小宽度为32px
            if (moveLenght > maxT - 400) moveLenght = maxT - 400 //右边区域最小宽度为150px
            resize[i].style.left = moveLenght // 设置左侧区域的宽度
            for (let j = 0; j < left.length; j++) {
              if (moveLenght >= 500 && box[i].clientWidth - moveLenght - 5 >= 500) {
                // mid[j].style.width = (box[i].clientWidth - moveLenght - 5 )  + 'px'
                // left[j].style.width = moveLenght + 'px'
                let leftWidth = parseInt(moveLenght / box[i].clientWidth * 100)
                let rightWidth = parseInt((box[i].clientWidth - moveLenght - 5) / box[i].clientWidth * 100)
                left[j].style.width = leftWidth + '%'
                mid[j].style.width = rightWidth + '%'
              }
            }
            if (moveLenght >= 500 && box[i].clientWidth - moveLenght - 5 >= 500) {
              this.setState({ rightWidth: box[i].clientWidth - moveLenght - 29, leftWidth: moveLenght - 24 })
            }
          };
          document.onmouseup = () => {
            resize[i].style.background = '#fff'
            document.onmousemove = null
            document.onmouseup = null
            resize[i].releaseCapture && resize[i].releaseCapture()
          };
          resize[i].setCapture && resize[i].setCapture()
          return false
        }
      }
    },

    checkLinerTop() {
      return this.$refs['rawBlockTop'].list.records.some(i => i.percentage === '' || i.percentage === null)
    },
    checkLinerBottom() {
      return this.$refs['rawBlockBottom'].list.records.some(i => i.percentage === '' || i.percentage === null)
    },

    saveCompound() {
      if (this.checkLinerTop() || this.checkLinerBottom()) {
        this.$message.warning('配方还未优化,无法更新配方版本')
        return
      }
      this.$confirm({
        title: '保存提醒',
        content: '配方没有进行优化，或者优化后无解的情况，无法更新配方版本。',
        cancelText: '取消',
        okText: '保存并更新版本',
        onOk: () => this.formulaProduct(),
        // onCancel:()=> this.saveFormulaProVersion()
      })
    },

    async saveProductCompound() {
      if (!this.checkRawTop() || !this.checkRawBottom()) {
        this.$message.warning('配方中没有原料，无法生成产品！')
        return
      }
      if (this.detail.formulaSolutionType !== '1') {
        this.$message.warning('配方还未优化,无法生成产品！')
        return
      }
      await this.saveProduce()
    },
    checkRawTop() {
      return this.$refs['rawBlockTop'].list.records && this.$refs['rawBlockTop'].list.records.length > 0
    },
    checkRawBottom() {
      return this.$refs['rawBlockBottom'].list.records && this.$refs['rawBlockBottom'].list.records.length > 0
    },

    async saveFormulaProVersion() {
      await this.fetchPost({
        actions: this.saveProVersion,
        loading: 'saveLoading',
        data: {
          formulaId: this.formulaId
        }
      })
      // this.getDetail();
      // this.$message.success('配方已保存！')
      this.refreshPage()
    },

    async formulaProduct() {
      await this.fetchPost({
        actions: this.saveMixFormulaProduct,
        loading: 'saveLoading',
        data: {
          formulaId: this.formulaId
        }
      })
      // this.getDetail()

      // this.refreshPage()
    },

    async saveProduce() {
      const hide = this.$message.loading('产品生成中，请稍后...', 0)
      await this.fetchPost({
        actions: this.saveMixFormulaInfoPro,
        loading: 'saveLoading',
        data: { formulaId: this.formulaId }
      })
      // this.getDetail()
      this.refreshPage()
      setTimeout(hide, 0)
    },

    async saveFormula({ key }) {
      const actions = [this.saveFormulaProVersion, this.saveCompound, this.saveProductCompound]
      // const actions = [this.saveCompound,this.saveProductCompound]
      let flag = true
      if (key == 2) {
        if (this.detail.formulaSolutionType === '0') {
          flag = false
          this.$message.warning('请先进行配方优化')
        }
      }
      if (!flag) return
      await actions[key]()
      this.setState({ calculaVisible: false, nutVisible: false })
      // if(this.$refs.nutritionBlock) this.$refs.nutritionBlock.init()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .ant-tabs-bar {
  margin: 0 10px;
}
//   ::v-deep .ant-table-body::-webkit-scrollbar, ::v-deep.list-container::-webkit-scrollbar {
//     width : 4px;
//     height: 4px;
//   }
//   ::v-deep .ant-table-body::-webkit-scrollbar-thumb,::v-deep.list-container::-webkit-scrollbar-thumb {
//     border-radius: 0;
//     background   : #888;
//   }
//   ::v-deep .ant-table-body::-webkit-scrollbar-track,::v-deep.list-container::-webkit-scrollbar-track {
//     border-radius: 0;
//     background : #e8e8e8;
//   }
//   ::v-deep .ant-table-body::-webkit-scrollbar-corner {
//     background:#e8e8e8;
//   }
</style>
<style lang="scss">
.ant-tooltip-inner {
  font-size: 12px;
}
.vue-simple-context-menu {
  box-shadow: 0 4px 12px rgba($color: #000000, $alpha: 0.3);
  background: #fff;
  &--active {
    background: #fff;
    color: #444;
  }
  &__item {
    width: 180px;
    font-size: 13px;
    span {
      width: 180px;
      display: flex;
      justify-content: space-between;
      padding: 3px 0;
      b {
        font-weight: normal;
      }
    }
    i {
      width: 13px;
      height: 7px;
      border: 2px solid #1890ff;
      border-top: none;
      border-right: none;
      transform: rotate(-45deg) scale(0.9) translateY(4px);
    }
    &:hover {
      background-color: lighten(#1890ff, 44%);
      color: #1890ff;
    }
  }

  &__divider {
    height: 1px;
    background-color: #e8e8e8;
  }
}
.tableleft,
.tableright,
.resize {
  float: left;
}
.nhf-editor {
  overflow: hidden;
  &-container {
    max-width: 1400px;
    margin: 0 auto;
  }
}
.nhf-app {
  overflow: hidden;
  height: 100vh;
  max-height: 100vh;
  min-width: 1050px;
  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    padding: 0;
  }
}
.nhf-layout h2 {
  font-size: 14px;
  padding: 15px !important;
}
.nhf-header {
  padding: 10px 20px 0;
}
.nhf-title {
  font-size: 14px;
  font-weight: 800;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.nhf-logo {
  // width:80px;
  height: 23px;
  margin-right: 8px;
}
.nhf-title span {
  color: #1890ff;
  padding: 0 4px;
  border-left: 4px solid #1890ff;
  line-height: 12px;
}
.nhf-header-main {
  padding: 8px 15px 4px;
  border-bottom: 1px solid #e8e8e8;
}
.nhf-header-main h3 {
  font-size: 18px;
  color: #444;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  position: relative !important;
}
.ant-table-row-cell-break-word {
  position: relative !important;
}
.nhf-container {
  border-radius: 5px;
  background: #fff;
  min-width: 800px;
  margin: 10px 20px 15px;
  height: calc(100vh - 70px);
  border-radius: 5px;
  background: #fff;
}
.editor-container {
  flex: 1;
}
.col {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  h2 {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 18px;
    font-weight: 900;
    color: #444;
    span {
      &.red {
        color: red;
      }
      &.green {
        color: green;
      }
      b {
        color: #444;
        margin: 0 4px;
      }
    }
  }
}
.ant-layout-content {
  min-height: 100vh;
}
.appBox {
  height: inherit impor !important;
}
.resizeBottom {
  cursor: row-resize;
  height: 4px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:hover {
    color: #444444;
  }
  &:after {
    top: -2px;
    bottom: -2px;
    border: 1px solid #888;
    border-left: none;
    border-right: none;
    width: 22px;
    content: "";
    position: absolute;
    left: 50%;
  }
  &:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    background-color: #e8e8e8;
    height: 1px;
  }
}
.resize {
  cursor: col-resize;
  width: 4px;
  height: calc(100vh - 132px);
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:hover {
    color: #444444;
  }
  &:after {
    left: -2px;
    right: -2px;
    border: 1px solid #888;
    border-top: none;
    border-bottom: none;
    height: 22px;
    content: "";
    margin-top: -11px;
    position: absolute;
    top: 50%;
  }
  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    background-color: #e8e8e8;
    width: 1px;
  }
}
</style>